import React from 'react'
import Page from '../components/Page'
import RowList from '../components/Main/RowList'
import Accordion from '../components/Main/Accordion'

export default function Faqs (props) {
  const { faq_section: faqSection } = props.acf
  const fullArticle = props.wp

  return (
    <React.Fragment>
      <Page
        title={'FAQs'}
        slug={'/' + fullArticle.slug}
        body={
          'A list of frequently asked questions about The Quell Foundation. Currently, there are 3 categories of FAQs: scholarships, fundraising events, and screenings'
        }
      >
        <main id='content'>
          <div className='container single-page'>
            <RowList singlePage title={props.wp.title.rendered} />
            <Accordion section={faqSection} />
          </div>
        </main>
      </Page>
    </React.Fragment>
  )
}
